import { svgImages } from "@/lib/svgImages";
import styles from "./planCardV2.module.scss";
import Link from "next/link";
import ButtonBgAnimate from "../buttonBgAnimate/buttonBgAnimate";

const PlanCardV2 = ({
  title,
  price,
  annualCost,
  buttonUrl,
  buttonTitle,
  mostPopular,
  isAnnual,
  compareFeatures,
  currencySymbol,
  freeTrailValue,
  featureList,
  hideFeatureList,
  planName,
}) => {
  return (
    <div
      className={`${styles["planCardV2"]} ${
        mostPopular ? styles["mostPopular"] : ""
      } ${compareFeatures ? styles["compareFeatures"] : ""}`}
    >
      {mostPopular && (
        <div className={`${styles["mostPopular"]}`}>
          <div
            className={`${styles["icon"]}`}
            dangerouslySetInnerHTML={{ __html: svgImages.stars }}
          />
          <div className={`${styles["text"]}`}>Most Popular</div>
        </div>
      )}
      <div className={`${styles["planCardV2TitleContainer"]}`}>
        <div className={`${styles["title"]} font-size-24`}>{title}</div>

        <div className={`${styles["priceContainer"]}`}>
          <div className={`${styles["price"]} font-size-20`}>
            {currencySymbol}
            {price}
            <span className={`${styles["priceNumber"]}`}>{" /mo."}</span>
          </div>
        </div>
      </div>
      <div className={`${styles["planCardV2BilledTypeContainer"]}`}>
        <div className={`${styles["billedType"]}`}>
          <span className={`${styles["billedTypeText"]}`}>
            Billed {isAnnual ? "Annually" : "Monthly"}
          </span>
          <span className={`${styles["annualCost"]}`}>
            {isAnnual && price !== "0" && (
              <span>
                {annualCost} {currencySymbol} {" / year"}
              </span>
            )}
          </span>
        </div>
      </div>
      {!hideFeatureList && (
        <div className={`${styles["planCardV2Divider"]}`}></div>
      )}

      {!hideFeatureList && (
        <div className={`${styles["featureList"]}`}>
          {featureList.map((feature, index) => {
            const planData =
              typeof feature === "string"
                ? { value: feature, disabled: false }
                : typeof feature.value === "object"
                ? feature.value[planName] || { value: "", disabled: false }
                : { value: feature.value, disabled: false };

            const featureValue = planData.value;
            const isDisabled = planData.disabled;

            return (
              <div
                className={`${styles["feature"]}`}
                key={index}
                style={{ opacity: isDisabled ? 0.5 : 1 }}
              >
                {typeof feature === "string" ? (
                  feature
                ) : (
                  <span className={`${styles["featureValue"]}`}>
                    {typeof featureValue === "object" && featureValue.icon ? (
                      <div className={`${styles["featureValueIcon"]}`}>
                        <span className={`${styles["featureValueIconItem"]}`}>
                          {featureValue.icon}
                        </span>
                        {featureValue.text && <span> {featureValue.text}</span>}
                      </div>
                    ) : (
                      featureValue
                    )}
                  </span>
                )}
                {feature.title}
              </div>
            );
          })}
        </div>
      )}

      {/* <div className={`${styles["button"]}`}>
        {mostPopular === false ? (
          <ButtonBgAnimate
            title={buttonTitle}
            url={buttonUrl}
            outline={false}
          />
        ) : (
          <Link href={buttonUrl}>{buttonTitle}</Link>
        )}
      </div> */}
      {/* <div className={`${styles["trailText"]} font-size-14`}>
        {freeTrailValue && `${freeTrailValue} Days Free Trial`}
      </div> */}
    </div>
  );
};

export default PlanCardV2;
